import { render, staticRenderFns } from "./create-price.vue?vue&type=template&id=7bb22846&"
import script from "./create-price.vue?vue&type=script&lang=ts&"
export * from "./create-price.vue?vue&type=script&lang=ts&"
import style0 from "./create-price.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports